export default __webpack_public_path__ + "static/media/596.fb69920c.png";